import clsx from 'clsx';
import { ReactNode } from 'react';

import { UnpackArray } from '../..';

import styles from './Diff.module.scss';
import { DiffValueProps } from './DiffValue';


interface ArrayDiffValueProps<TArrayValue extends Array<any>>
    extends Omit<DiffValueProps<TArrayValue>, 'renderValue'>
{
    disableNone?: boolean;
    valueContainerClassName?: string;
    renderValue?: (value: UnpackArray<TArrayValue>) => ReactNode;
}

export function ArrayDiffValue<TArrayValue extends Array<any>>({
    originalValue, updatedValue, renderValue, isCreate, isDelete, disableNone, hideIfUnchanged, valueContainerClassName
}: ArrayDiffValueProps<TArrayValue>) {
    type TRenderValue = UnpackArray<TArrayValue>;
    const originalValueSet = new Set<'None' | TRenderValue>(originalValue);
    const updatedValueSet = new Set<'None' | TRenderValue>(updatedValue);

    if (!disableNone) {
        if (!isCreate && originalValueSet.size === 0) {
            originalValueSet.add('None');
        }

        if (!isDelete && updatedValueSet.size === 0) {
            updatedValueSet.add('None');
        }
    }

    const allValuesSet = new Set([ ...originalValueSet, ...updatedValueSet ]);

    return (
        <>
            {([ ...allValuesSet ]).map((value) => ((
                !hideIfUnchanged || !updatedValueSet.has(value) || !originalValueSet.has(value)) ? (
                    <div
                        key={(value as object).toString()}
                        className={clsx(valueContainerClassName, {
                            [styles.oldDiffValue]: !updatedValueSet.has(value),
                            [styles.newDiffValue]: !originalValueSet.has(value)
                        })}
                    >
                        {value === 'None'
                            ? value
                            : renderValue?.(value) || value}
                    </div>
                ) : null))}
        </>
    );
}
